import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { KeyValueModel } from '../models/key-value.model';
import { ConsoleService } from './console.service';

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  constructor(public translate: TranslateService) {}

  //#region number convertor

  getTextWithArabicNumber(text): string {
    let arabicNumbers = new Array(
      '٠',
      '١',
      '٢',
      '٣',
      '٤',
      '٥',
      '٦',
      '٧',
      '٨',
      '٩'
    );
    let str = text + '';
    for (let num in arabicNumbers) {
      let reg = new RegExp(num, 'g');
      str = str.replace(reg, arabicNumbers[num]);
    }
    return str;
  }

  getTextWithEnglishNumber(text): string {
    let arabicNumbers = new Array(
      '٠',
      '١',
      '٢',
      '٣',
      '٤',
      '٥',
      '٦',
      '٧',
      '٨',
      '٩'
    );
    let farsiNumbers = new Array(
      '۰',
      '۱',
      '۲',
      '۳',
      '۴',
      '۵',
      '۶',
      '۷',
      '۸',
      '۹'
    );
    let str = text + '';
    for (let num = 0; num < farsiNumbers.length; num++) {
      let reg = new RegExp(farsiNumbers[num], 'g');
      str = str.replace(reg, num.toString());
    }
    for (let num = 0; num < arabicNumbers.length; num++) {
      let reg = new RegExp(arabicNumbers[num], 'g');
      str = str.replace(reg, num.toString());
    }
    return str;
  }

  //#endregion

  //#region sms

  getSmsPart(smsBody, udhLen): { smsPart?: number; remainingChar?: number } {
    if (!smsBody) return { smsPart: 0, remainingChar: 0 };

    let standardSmsLen = 160;
    let standardUdhLen = 7;
    if (this.hasUniCodeCharacter(smsBody)) {
      standardSmsLen = 70;
      standardUdhLen = 4;
      if (udhLen > 0) standardUdhLen = udhLen;
    }

    const smsLen = smsBody?.length;

    if (smsLen > standardSmsLen) {
      const smsPart = Math.ceil(smsLen / (standardSmsLen - standardUdhLen));
      const remainingChar =
        Math.abs(smsLen - (standardSmsLen - standardUdhLen) * smsPart) + 1;
      return { smsPart, remainingChar };
    } else {
      const smsPart = Math.ceil(smsLen / standardSmsLen);
      const remainingChar = Math.abs(smsLen - standardSmsLen) + 1;
      return { smsPart, remainingChar };
    }
  }

  getSeperatedSmsBodyByPart(smsBody: string, udhLen): string {
    //Calculate standard udhLen and standard smsLen
    let standardSmsLen = 160;
    let standardUdhLen = 7;
    if (this.hasUniCodeCharacter(smsBody)) {
      standardSmsLen = 70;
      standardUdhLen = 4;
      if (udhLen > 0) standardUdhLen = udhLen;
    }

    let currentPart = 1;
    let lastStartIndex: number = 0;
    let spanList: string[] = [];
    let spanContent = '';

    for (let i = 0; i < smsBody.length; i++) {
      let part;
      let smsLen = i + 1;

      //calculate part
      if (smsLen > standardSmsLen)
        part = Math.ceil(smsLen / (standardSmsLen - standardUdhLen));
      else part = Math.ceil(smsLen / standardSmsLen);

      spanContent = `<span>${smsBody.slice(lastStartIndex, i + 1)}</span>`;

      if (part > currentPart) {
        spanList.push(spanContent);
        currentPart = part;
        lastStartIndex = i;
      }
    }

    if (!spanList.length) spanList.push(spanContent);
    ConsoleService.info('spanList', spanList);
    return spanList.join('');
  }

  hasUniCodeCharacter(value) {
    return /[^\u0000-\u00ff]/.test(value);
  }

  //#endregion

  //#region string

  static getNumbersFromString(text: string): string {
    if (!text) return;
    let result: string;
    result = text.replace(/,/g, '\n');
    return result.getJustNumber();
  }

  //#endregion

  //#region enums

  enumValuesToArray(enume: any): number[] {
    const stringIsNumber = (value) => isNaN(Number(value)) === false;
    return <number[]>Object.values(enume)
      .filter(stringIsNumber)
      .map((value) => value);
  }

  enumeKeysToArray(enume: any) {
    const stringIsNumber = (value) => isNaN(Number(value)) === false;
    return Object.keys(enume)
      .filter(stringIsNumber)
      .map((key) => enume[key]);
  }

  enumToObject(enume: any): KeyValueModel[] {
    let array = <KeyValueModel[]>(
      Object.entries(enume).map(([key, value]) => ({ key, value }))
    );

    return array.splice(array.length / 2, array.length);
  }

  enumToObjectWithTranslate(enume: any, enumeName: string): KeyValueModel[] {
    let array = <KeyValueModel[]>(
      Object.entries(enume).map(([key, value]) => ({ key, value }))
    );

    array = array.splice(array.length / 2, array.length);

    return array.map((item) => {
      return {
        key: this.translate.instant(`enums.${enumeName}.${item.key}`),
        value: item.value,
      };
    });
  }

  //#endregion
}
